import { isBlockLoaded } from './loadingState';

/**
 * Keeps dashboard blocks visible with a skeleton loader until sequential loading completes.
 */
export function SequentialBlock({
  loadingState,
  section,
  block,
  skeleton,
  children,
  className,
}) {
  if (!isBlockLoaded(loadingState, section, block)) {
    return (
      <div
        className={`dash-block-loader ${className}`.trim()}
        aria-busy="true"
        aria-live="polite"
      >
        {skeleton}
      </div>
    );
  }

  return children;
}
